import en from './developers.en';

const enConfig = { en };

export default enConfig;
